var map = {
	"./1.png": 675,
	"./10.png": 3083,
	"./11.png": 1538,
	"./12.png": 6073,
	"./13.png": 1872,
	"./2.png": 6184,
	"./3.png": 801,
	"./4.png": 4686,
	"./5.png": 7703,
	"./6.png": 7068,
	"./7.png": 6485,
	"./8.png": 9538,
	"./9.png": 667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4291;